import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve } from '@angular/router'
import { Estabelecimento } from '../../pkw-data/collect/estabelecimento/estabelecimento.model'
import { ListaPaginada } from '../../pkw-data/core/util/lista-paginada.model'
import { EstabelecimentoService } from './estabelecimento.service'
import { FiltroEstabelecimento } from './filtro-estabelecimento'

@Injectable()
export class EstabelecimentosResolver implements Resolve<EstabelecimentosRouteValues> {
    constructor(private estabelecimentoService: EstabelecimentoService) {}

    resolve(route: ActivatedRouteSnapshot) {
        const filtro = new FiltroEstabelecimento()
        filtro.carente = !!route.queryParams.listarCarentes

        return this.estabelecimentoService.pesquisar(filtro.toFilter()).map(resultado => {
            return {
                filtro,
                resultado
            }
        })
    }
}

export interface EstabelecimentosRouteValues {
    filtro: FiltroEstabelecimento
    resultado: ListaPaginada<Estabelecimento>
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/shared/estabelecimentos.resolver.ts